import React, { FunctionComponent } from 'react';

import { TextOverflow } from '../../Common/CommonStyles';

export const UploadedFile: FunctionComponent<{
  filename: string;
}> = ({ filename }) => (
  <TextOverflow>
    {filename}
  </TextOverflow>
);
